<script>
	export let bodyText = 'You can end the round or app from here.';
	export let fontSize = '16';
	export let padding = '16';
</script>

<div class="basicInfoContainer">
	<div class="svgWrapper">
		<svg class="svg" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M9.28406 1.86596C10.0605 0.569146 11.9395 0.569146 12.7159 1.86596L21.3118 16.2226C22.1099 17.5557 21.1496 19.25 19.5958 19.25H2.40419C0.850432 19.25 -0.109913 17.5557 0.688247 16.2226L9.28406 1.86596Z"
				fill="white"
			/>
		</svg>
	</div>
	<div class="content" style="padding:{padding}px">
		<div class="info" style="font-size:{fontSize}px">💡Info</div>
		<div class="body" style="font-size:{fontSize}px">{bodyText}</div>
	</div>
</div>

<style>
	.basicInfoContainer {
		width: 189px;
	}
	.svgWrapper {
		width: 100%;
		height: 20px;
		box-sizing: border-box;
		display: flex;
		justify-content: flex-end;
		margin-bottom: -6px;
	}
	.svg {
		margin-right: 18px;
	}
	.content {
		width: 100%;
		height: 115px;
		box-sizing: border-box;
		background: #fffeff;
		border-radius: 21px;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
	}
	.info {
		width: 63px;
		height: 28px;
		background: #e1cefe;
		border-radius: 31px;
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		line-height: 22px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #522a8d;
		padding-right: 2px;
	}
	.body {
		font-family: Pally;
		font-style: normal;
		font-weight: 500;
		line-height: 22px;
		color: #522a8d;
	}
</style>
